/**
 * @description 各cms読み込みとcms読み込み共通
 */

import { setid } from './setid';
import { loadInformation } from './loadInformation';
import { loadPlan } from './loadPlan';
import { loadTopics } from './loadTopics';
import { loadEachPlan } from './loadEachPlan';
import { loadEachTopics } from './loadEachTopics';

export const loadcms = () => {
  setid().then(() => {
    loadInformation();
    loadPlan();
    loadTopics();
    loadEachTopics();
    loadEachPlan();
  });
};

/**
 * @description 共通html
 */
export const cmsSliderHtml = (link: string, img: string, title: string, discription: string) => {
  return `
  <div class="swiper-slide">
    <a href="${link}" class="card">
      <div class="image"><img src="${img}" alt="${title}"></div>
      <div class="area"><span class="bold">${title}</span><br>${discription}</div>
    </a>
  </div>
  `;
};

/**
 * @description 共通の型
 */

export interface PostType {
  id: number;
  date: string;
  link: string;
  title: Title;
  facility_name: number[];
  acf: Acf;
}

interface Acf {
  date: string;
  top: boolean;
}

interface Title {
  rendered: string;
}
